function PrivacyPolicy() {
  return (
    <div className="mx-auto max-w-5xl px-4 pb-12 pt-24">
      <div className="mb-6 rounded-[28px] border border-white/10 bg-slate-900/70 p-6 shadow-2xl shadow-slate-950/30 backdrop-blur">
        <p className="text-sm font-semibold uppercase tracking-[0.35em] text-cyan-300">Tietosuoja</p>
        <h1 className="mt-2 text-3xl font-black text-white md:text-4xl">Disc Golf Reikäpeli Cup tietosuojaseloste</h1>
        <p className="mt-3 text-sm leading-6 text-slate-300">
          Päivitetty 18.4.2026. Tämä seloste kuvaa, mitä henkilötietoja palvelussa käsitellään, mihin niitä käytetään
          ja mitä oikeuksia käyttäjällä on.
        </p>
      </div>

      <div className="space-y-6">
        <section className="rounded-[28px] border border-white/10 bg-slate-900/70 p-6 shadow-2xl shadow-slate-950/30 backdrop-blur">
          <h2 className="text-xl font-bold text-white">1. Rekisterinpitäjä</h2>
          <div className="mt-4 space-y-2 text-sm leading-6 text-slate-300">
            <p>Wirmo Discgolf Mynämäki ry / Disc Golf Reikäpeli Cup</p>
            <p>Sähköposti: info@wirmodiscgolf.fi</p>
            <p>Rekisterin nimi: Disc Golf Reikäpeli Cup käyttäjä-, kilpailu- ja tulosrekisteri</p>
          </div>
        </section>

        <section className="rounded-[28px] border border-white/10 bg-slate-900/70 p-6 shadow-2xl shadow-slate-950/30 backdrop-blur">
          <h2 className="text-xl font-bold text-white">2. Mitä tietoja kerätään</h2>
          <div className="mt-4 space-y-3 text-sm leading-6 text-slate-300">
            <p>Palvelussa voidaan käsitellä seuraavia käyttäjän antamia tai palvelun käytössä muodostuvia tietoja:</p>
            <p>Etunimi ja sukunimi.</p>
            <p>Sähköpostiosoite.</p>
            <p>Puhelinnumero.</p>
            <p>Paikkakunta.</p>
            <p>Syntymävuosi.</p>
            <p>Sukupuoli.</p>
            <p>Salasana tallennetaan vain vahvasti hajautettuna, ei selkokielisenä.</p>
            <p>Käyttäjätilin suostumukset ja niiden ajankohdat.</p>
            <p>Käyttäjätilin tekniset tunnistetiedot, kuten käyttäjätunniste ja kirjautumiseen liittyvä tunniste.</p>
            <p>Kilpailuihin ilmoittautumiset, luokat, otteluparit, väylä- ja kierrostulokset sekä vuositilastot.</p>
            <p>Palvelun virhe- ja tapahtumalokeihin voi tallentua teknisiä tietoja, kuten aikaleimoja ja virheilmoituksia.</p>
          </div>
        </section>

        <section className="rounded-[28px] border border-white/10 bg-slate-900/70 p-6 shadow-2xl shadow-slate-950/30 backdrop-blur">
          <h2 className="text-xl font-bold text-white">3. Mistä tiedot saadaan</h2>
          <div className="mt-4 space-y-3 text-sm leading-6 text-slate-300">
            <p>Tiedot saadaan pääasiallisesti käyttäjältä itseltään rekisteröitymisen ja profiilin päivittämisen yhteydessä.</p>
            <p>Tuloksiin, otteluihin ja tilastoihin liittyvät tiedot muodostuvat palvelun käytön aikana kilpailuihin osallistumisesta.</p>
          </div>
        </section>

        <section className="rounded-[28px] border border-white/10 bg-slate-900/70 p-6 shadow-2xl shadow-slate-950/30 backdrop-blur">
          <h2 className="text-xl font-bold text-white">4. Mihin tietoja käytetään</h2>
          <div className="mt-4 space-y-3 text-sm leading-6 text-slate-300">
            <p>Käyttäjätilin luomiseen, kirjautumiseen, tunnistamiseen ja salasanan hallintaan.</p>
            <p>Kilpailuihin ilmoittautumisen käsittelyyn ja käyttäjän kilpailukelpoisuuden arviointiin, kuten luokan sukupuoli- ja ikärajoihin.</p>
            <p>Otteluparien muodostamiseen, tulosten kirjaamiseen, tulosten vahvistamiseen ja kilpailun etenemisen näyttämiseen.</p>
            <p>Vuositilastojen, tulosten, kaavioiden ja muiden kilpailuun liittyvien näkymien muodostamiseen.</p>
            <p>Yhteydenpidon mahdollistamiseen otteluosapuolten välillä. Puhelinnumero ja sähköpostiosoite eivät ole julkisesti nähtävillä, mutta ne voidaan näyttää käyttäjän seuraavalle vastustajalle peliajan sopimista varten käyttäjän antaman suostumuksen perusteella.</p>
            <p>Paikkakunnan näyttämiseen kilpailujen osallistujalistoissa ja seuraavan vastustajan tiedoissa, jotta otteluparit tunnistavat toisensa paremmin.</p>
            <p>Palveluun liittyvien sähköpostien lähettämiseen, kuten salasanan uusimiseen sekä ottelun tuloksen vahvistusmuistutuksiin.</p>
            <p>Palvelun turvallisuuden, virhetilanteiden selvittämisen ja ylläpidon varmistamiseen.</p>
          </div>
        </section>

        <section className="rounded-[28px] border border-white/10 bg-slate-900/70 p-6 shadow-2xl shadow-slate-950/30 backdrop-blur">
          <h2 className="text-xl font-bold text-white">5. Käsittelyn perusteet</h2>
          <div className="mt-4 space-y-3 text-sm leading-6 text-slate-300">
            <p>Henkilötietoja käsitellään ensisijaisesti palvelun tarjoamiseksi ja kilpailujen järjestämiseksi käyttäjän pyynnöstä.</p>
            <p>Puhelinnumeron ja sähköpostiosoitteen näyttäminen seuraavalle vastustajalle perustuu käyttäjän antamaan suostumukseen.</p>
            <p>Tietosuojaselosteen hyväksyntä tallennetaan osoituksena siitä, että käyttäjä on saanut tiedon henkilötietojen käsittelystä.</p>
          </div>
        </section>

        <section className="rounded-[28px] border border-white/10 bg-slate-900/70 p-6 shadow-2xl shadow-slate-950/30 backdrop-blur">
          <h2 className="text-xl font-bold text-white">6. Tietojen näkyvyys ja luovutukset</h2>
          <div className="mt-4 space-y-3 text-sm leading-6 text-slate-300">
            <p>Käyttäjän nimeä voidaan näyttää palvelussa kilpailuihin, ottelupareihin, tuloksiin ja tilastoihin liittyvissä näkymissä.</p>
            <p>Käyttäjän paikkakunta voidaan näyttää kilpailujen rekisteröityneiden pelaajien listalla sekä seuraavan vastustajan yhteystietonäkymässä.</p>
            <p>Puhelinnumeroa ja sähköpostiosoitetta ei näytetä julkisesti sivustolla.</p>
            <p>Puhelinnumero ja sähköpostiosoite näytetään vain käyttäjän seuraavalle vastustajalle pelien sopimista varten, jos käyttäjä on antanut tähän suostumuksen.</p>
            <p>Tietoja ei luovuteta kolmansille osapuolille.</p>
            <p>Tietoja ei siirretä Euroopan unionin tai Euroopan talousalueen ulkopuolelle rekisterinpitäjän toimesta.</p>
          </div>
        </section>

        <section className="rounded-[28px] border border-white/10 bg-slate-900/70 p-6 shadow-2xl shadow-slate-950/30 backdrop-blur">
          <h2 className="text-xl font-bold text-white">7. Säilytysajat</h2>
          <div className="mt-4 space-y-3 text-sm leading-6 text-slate-300">
            <p>Käyttäjätilin perustiedot säilytetään lähtökohtaisesti niin kauan kuin käyttäjätili on aktiivinen.</p>
            <p>Kilpailuihin, tuloksiin ja tilastoihin liittyviä tietoja voidaan säilyttää pidempään kilpailuhistorian ja palvelun toiminnan vuoksi.</p>
            <p>Suostumustiedot ja niiden aikaleimat säilytetään niin kauan kuin ne ovat tarpeen suostumuksen osoittamiseksi.</p>
            <p>Virhe- ja tapahtumalokeja säilytetään vain niin kauan kuin se on tarpeen tietoturvan, ylläpidon ja virheiden selvittämisen kannalta.</p>
          </div>
        </section>

        <section className="rounded-[28px] border border-white/10 bg-slate-900/70 p-6 shadow-2xl shadow-slate-950/30 backdrop-blur">
          <h2 className="text-xl font-bold text-white">8. Rekisteröidyn oikeudet</h2>
          <div className="mt-4 space-y-3 text-sm leading-6 text-slate-300">
            <p>Käyttäjällä on oikeus tarkastaa itseään koskevat tiedot.</p>
            <p>Käyttäjällä on oikeus pyytää virheellisten tai puutteellisten tietojen oikaisua.</p>
            <p>Käyttäjällä on oikeus pyytää tietojensa poistamista, jos tietojen säilyttämiselle ei ole enää perustetta.</p>
            <p>Käyttäjällä on oikeus peruuttaa antamansa suostumus yhteystietojen näyttämiseen seuraavalle vastustajalle. Suostumuksen peruuttaminen voi estää palvelun täyden käytön pelien sopimisen osalta.</p>
            <p>Käyttäjällä on oikeus tehdä valitus tietosuojavaltuutetulle, jos hän katsoo, että henkilötietojen käsittelyssä rikotaan soveltuvaa tietosuojalainsäädäntöä.</p>
          </div>
        </section>

        <section className="rounded-[28px] border border-white/10 bg-slate-900/70 p-6 shadow-2xl shadow-slate-950/30 backdrop-blur">
          <h2 className="text-xl font-bold text-white">9. Tietojen suojaus</h2>
          <div className="mt-4 space-y-3 text-sm leading-6 text-slate-300">
            <p>Tiedot säilytetään palvelun tietokannassa ja niitä käsitellään käyttöoikeuksin rajatusti.</p>
            <p>Salasanoja ei tallenneta selkokielisinä, vaan hajautettuina.</p>
            <p>Kirjautuneen käyttäjän istuntoa hallitaan tunnisteella, jota käytetään palvelun suojattujen toimintojen yhteydessä.</p>
          </div>
        </section>

        <section className="rounded-[28px] border border-white/10 bg-slate-900/70 p-6 shadow-2xl shadow-slate-950/30 backdrop-blur">
          <h2 className="text-xl font-bold text-white">10. Automaattinen päätöksenteko</h2>
          <div className="mt-4 space-y-3 text-sm leading-6 text-slate-300">
            <p>Palvelussa ei tehdä käyttäjää koskevia automaattisia päätöksiä tai profilointia tietosuojalainsäädännössä tarkoitetulla tavalla.</p>
          </div>
        </section>

        <section className="rounded-[28px] border border-white/10 bg-slate-900/70 p-6 shadow-2xl shadow-slate-950/30 backdrop-blur">
          <h2 className="text-xl font-bold text-white">11. Yhteydenotot</h2>
          <div className="mt-4 space-y-3 text-sm leading-6 text-slate-300">
            <p>Tietosuojaan liittyvissä kysymyksissä voit ottaa yhteyttä osoitteeseen info@wirmodiscgolf.fi.</p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;